import { useContext, useMemo } from 'react';

import { GridWidgetsContext } from '../GridWidgetsContext';

export const usePlaceholderPosition = () => {
  const { dragInfo, temporaryWidgetPositions, widgetSizes } =
    useContext(GridWidgetsContext);

  return useMemo(() => {
    const draggedWidget =
      dragInfo && temporaryWidgetPositions
        ? temporaryWidgetPositions.find(({ id }) => id === dragInfo.id)
        : null;

    if (!draggedWidget) {
      return null;
    }

    const { top, left, width } = draggedWidget.position;
    const { height } = widgetSizes[draggedWidget.id] || {};

    return {
      top,
      left,
      width,
      height,
    };
  }, [dragInfo, temporaryWidgetPositions]);
};
